import NodesGenerator from "../DataProcessing/NodesGenerator/NodesGenerator";
import LinksGenerator from "../DataProcessing/LinksGenerator/LinksGenerator";

export default class DataTranslator {
    // Public:
    compute(rawData) {
        this.rawData = rawData;
        this.initResult();
        if (this.isDataFormatOkay()) {
            this.computeNodes();
            this.computeLinks();
        }
        this.packResult();
        return this.result;
    }

    // Private:
    initResult() {
        this.nodes = [];
        this.links = [];
    }

    packResult() {
        this.result = {
            nodes: this.nodes,
            links: this.links,
        };
    }
    isDataFormatOkay() {
        return true;
    }

    computeNodes() {
        const rawData = this.rawData;
        const nodes = new NodesGenerator().compute(rawData);
        this.nodes = nodes;
    }

    computeLinks() {
        const nodes = this.nodes;
        const links = new LinksGenerator().compute(nodes);
        this.links = links;
    }
}
